import * as Sentry from '@sentry/react';
import config from 'config';

Sentry.init({
  enabled: config.node.env === 'production',
  dsn: config.sentry.dsn,
  environment: config.target,
  release: config.app.releaseSha,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
  ],
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

const { ErrorBoundary, captureEvent, captureException, captureMessage, setUser, withScope } =
  Sentry;

export { ErrorBoundary, captureEvent, captureException, captureMessage, setUser, withScope };
